import React, { useEffect } from "react";
import { Table } from "antd";
import styles from "./PrintMedList.module.css";
import { Rings } from "react-loader-spinner";
import { useTranslation } from "react-i18next";

const PatientList = ({
  patients,
  selectedPatients,
  setSelectedPatients,
  setEditPatient,
  onSortChange,
}) => {
  const { t } = useTranslation("medList");

  useEffect(() => {
    if (patients.length) {
      patients.sort((a, b) => a.lastName.localeCompare(b.lastName));
      setSelectedPatients(
        patients.map((patient) => patient._id)
      )
    }
  }
  , [patients, setSelectedPatients]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter && sorter.order) {
      onSortChange(sorter.field, sorter.order);
    } else {
      onSortChange(null, null);
    }
  };

  const columns = [
    {
      title: t("firstNameLabel"),
      dataIndex: "firstName",
      align: "center",
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: t("lastNameLabel"),
      dataIndex: "lastName",
      align: "center",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      sortDirections: ['ascend', 'descend'],
      defaultSortOrder: 'ascend',
    },
    {
      title: t("languageLabel"),
      dataIndex: "language",
      align: "center",
      render: (value, record) =>
        t(value, { ns: "languages" }) ||
        `${t(record.facility.defaultLanguage, { ns: "languages" })} (${t(
          "default"
        )})`,
    },
    {
      title: t("actionLabel"),
      key: "action",
      align: "center",
      render: (_, record) => (
        <button
          onClick={() => {
            setEditPatient(record);
          }}
          className={styles.PrintMedList__buttonLink}
        >
          {t("editLanguageButton")}
        </button>
      ),
    },
  ];

  if (!patients.length) {
    return <Rings color="#089BAB" height={50} width={50} />
  }
  
  return (
    <div className={styles.PrintMedList__table}>
      <Table
        rowKey={"_id"}
        dataSource={patients}
        columns={columns}
        rowSelection={{
          selectedRowKeys: selectedPatients,
          onSelectAll: (selected, selectedRows, changeRows) => {
            if (selected) {
              // Select all patients (not just current page)
              setSelectedPatients(patients.map((patient) => {console.log(patient);return patient._id}));
            } else {
              // Deselect all patients
              setSelectedPatients([]);
            }
          },
          onSelect: (record, selected, selectedRows) => {
            if (selected) {
              // Add patient to selection
              setSelectedPatients(prev => [...prev, record._id]);
            } else {
              // Remove patient from selection
              setSelectedPatients(prev => prev.filter(id => id !== record._id));
            }
          }
        }}
        pagination={
          patients.length > 10
            ? {
                pageSize: 10,
                total: patients.length,
              }
            : false
        }
        onChange={handleTableChange}
      />
    </div>
  )
}

export default PatientList;